import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { IDeliveryService } from '../interfaces/deliveryService/ideliveryService';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class DeliveryServiceService {
  constructor(private http: HttpClient) {}

  getAll() {
    return this.http.get(
      `${environment.url}/service_deliveries`
    ).pipe(map((res: any) => res['hydra:member'])) as Observable<IDeliveryService[]>;
    // .pipe(map((res: any) => res['hydra:member']))
  }

  save(req: IDeliveryService) {
    return this.http.post(
      'https://api-fake-r9p5.onrender.com/delivery_services',
      req
    ) as Observable<IDeliveryService>;
  }

  edit(req: IDeliveryService, id: number) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/merge-patch+json',
    });
    return this.http.patch(
      `https://api-fake-r9p5.onrender.com/delivery_services/${id}`,
      req,
      { headers: headers }
    ) as Observable<IDeliveryService>;
  }

  delete(id: number) {
    return this.http.delete(
      `https://api-fake-r9p5.onrender.com/delivery_services/${id}`
    ) as Observable<IDeliveryService>;
  }
}
